import React from "react";
import { connect } from "react-redux";
import routes from "../../../assets/apiRoutes.json"
import {SelectBox} from 'devextreme-react/select-box';
import {TextBox} from 'devextreme-react/text-box';
import { GridLayout } from "../../../common/GridLayout";

import DataGrid, {
  Column,
  Editing,
  Paging,
  Toolbar,
  Item,
  FilterRow,
  FilterPanel,
  FilterBuilderPopup,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnFixing,
  Sorting,
  Export,
  Pager,
  HeaderFilter,
  StateStoring
} from 'devextreme-react/data-grid';
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";

import { createStore } from 'devextreme-aspnet-data-nojquery';

const filterBuilderPopupPosition = {
  of: window,
  at: 'top',
  my: 'top',
  offset: { y: 10 },
};

const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
const dataGrid = React.createRef();
let accessToken = '';

const gridKey = "6e2bc4b4-7ee4-4bba-8202-1cdba0d07720";

class EditStratLocations extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      location: "",
      pullorderno: "",
      currentLayout: "Default",
    };

    accessToken = props.oidc.user.access_token;
    var that = this;
    this.onContentReady = this.onContentReady.bind(this);
    this.onEditingStart = this.onEditingStart.bind(this);
    this.handleLocationChanged = this.handleLocationChanged.bind(this);
    this.handlePullOrderNoChanged = this.handlePullOrderNoChanged.bind(this);

    this.pullOrderNoDataSource = createStore({
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.maintenance.PullOrderNumbers}`,
      onBeforeSend: function(method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      }
    });

    this.dataSource = createStore({
      key: 'rowid',
      loadParams:
      {
        pullOrderNumber: function ()
        {
          if(that.state != null && that.state != undefined &&
            that.state.pullorderno != null && that.state.pullorderno != undefined &&
            that.state.pullorderno.value != null && that.state.pullorderno.value != undefined)
          {
            return that.state.pullorderno.value;
          }

          return "";
        }
      },
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.maintenance.AllStratLocations}`,
      updateUrl: `${window._env_.REACT_APP_APIS}/${routes.maintenance.UpdateStratLocation}`,
      onBeforeSend: function(method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      }
    });
  }
  setCurrentLayout =(value)=>{
    this.setState({
      currentLayout:value
    })
  }
  loadState = () => {return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, this.state.currentLayout);}
  saveState=(state)=> { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, this.state.currentLayout);}
  render() {
    return (
      <div className="h-100 m-0" style={{ height: '100%', overflowY: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <DataGrid
          style={{ flex: '1 1 auto', minHeight: 0 }}

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }} id="gridContainer"
          onContentReady={this.onContentReady}
          onEditingStart={this.onEditingStart}
          ref={dataGrid}
          showBorders={true}
          className="ATConfigurationGridStyle"
          rowAlternationEnabled={true}
          allowColumnReordering={true}
          columnAutoWidth={true}
        >
          <Paging
            enabled={true}
          />
          <Pager
            visible={true}
            showPageSizeSelector={true}
            allowedPageSizes={allowedPageSizes}
            showNavigationButtons={true}
            showInfo={true}
          />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <FilterBuilderPopup position={filterBuilderPopupPosition} />
          <ColumnChooser
            enabled={true}
            title="Choose Column"
            width={290}
            height={290}
            sortOrder="asc"
          >
            <ColumnChooserSearch
              enabled={true}
              editorOptions={{ placeholder: 'Search column' }} />
          </ColumnChooser>
          <HeaderFilter visible={true} />
          <ColumnFixing enabled={true}/>,
          <Export enabled={true} allowExportSelectedData={true} text="Export" />
          <Sorting mode="multiple"/>
          <Editing
            mode="cell"
            refreshMode="reshape"
            allowUpdating={true}
            allowAdding={false}
            allowDeleting={false} />
          <StateStoring
            enabled={true}
            type="custom"
            customLoad={this.loadState}
            storageKey={gridKey}
            customSave={this.saveState}
          />
          <Column dataField="prodlot" caption="Production Lot"  allowEditing={false} cssClass="column-readonly"  />
          <Column dataField="species" caption="Species"  allowEditing={false} cssClass="column-readonly"  />
          <Column dataField="pullordernumber" dataType="number" caption="Pull Order" allowEditing={false} alignment="left" cssClass="column-readonly"  />
          <Column dataField="stratrowbayshelf" caption="R.R.B.S"  />
          <Toolbar>
            <Item location="before">
              <TextBox
                className="margin-right"
                placeholder="Location"
                onValueChanged={this.handleLocationChanged}
                valueChangeEvent="input"
                />
            </Item>
            <Item location="before">
              <SelectBox
                placeholder="Pull Order"
                dataSource={this.pullOrderNoDataSource}
                onValueChanged={this.handlePullOrderNoChanged}
                searchEnabled={true}
                showClearButton={true}
              />
            </Item>
            <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={this.setCurrentLayout} />
                 </Item>
            <Item name="exportButton" />
            <Item name="columnChooserButton" />
          </Toolbar>
        </DataGrid>
      </div>
    );
  }

  onValueChanged(cell, e) {
    cell.component.cellValue(cell.row.rowIndex, "stratrowbayshelf", e);
    dataGrid.current.instance().saveEditData();
  }

  onContentReady(e) {
    if (!e.component._hasLoaded) {
      e.component._hasLoaded = true;
      e.component.option("dataSource", this.dataSource);
    }
  }

  onEditingStart(e) {
    if (e.column.dataField == "stratrowbayshelf")
    {
      if (e.data.stratrowbayshelf != this.state.location.value)
      {
        var rowIndex = e.component.getRowIndexByKey(e.key);
        e.component.cellValue(rowIndex, "stratrowbayshelf", this.state.location.value);
      }
    }
  }

  handleLocationChanged(value)
  {
    this.setState({
      location: value
    });
  }

  handlePullOrderNoChanged(value)
  {
    this.setState({
      pullorderno: value
    });

    dataGrid.current.instance().refresh();
  }

}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(EditStratLocations);
